import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProductsSelectorActions, ProductsSelectorFacade } from "./+state";

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [ProductsSelectorFacade, ProductsSelectorActions],
})
export class ProductsSelectorModule {}
